// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2dvph","header":"PatientQuestionnaire_header__1qSz9","info":"PatientQuestionnaire_info__3fEOQ"};